export function BankAccountItemSkeleton() {
    return (
        <div className='w-full p-2 mx-auto border rounded-md shadow border-skeleton'>
            <div className='flex flex-row items-center space-x-4 animate-pulse'>
                <div className='w-12 h-12 rounded-full bg-skeleton'></div>
                <div className='flex-1 py-1 space-y-2'>
                    <div className='w-3/4 h-4 rounded bg-skeleton'></div>
                    <div className='h-4 rounded bg-skeleton'></div>
                </div>
            </div>
        </div>
    )
}
